import type { VariantPage } from "@/lib/api/formatting/rorosTweed/productPage";
import type { PriceAndSize } from "@/lib/centra/selection/selectionFormatter";

import ProductDetails from "./ProductDetails/";

type InfoUI = VariantPage["info"] & {
  addPriceAndSize: PriceAndSize;
  gtagAddToCart: () => void;
};

const UI = (props: InfoUI) => {
  if (!props) {
    return <></>;
  }
  const info = props;

  return (
    <>
      <ProductDetails {...info} />
    </>
  );
};

export default UI;
